import { getAPI } from '../utils/api';
import endpoints from '../utils/endpoints';

export const getRevenueAnalytics = (queryPayload, callBack, errorCallback) => {
  return () => {
    getAPI(
      endpoints?.GET_REVENUE_ANALYTICS,
      queryPayload || {},
      (data) => {
        callBack(data);
      },
      (err) => {
        errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};
